import script from "./AddViolator.vue?vue&type=script&setup=true&lang=js"
export * from "./AddViolator.vue?vue&type=script&setup=true&lang=js"

import "./AddViolator.vue?vue&type=style&index=0&id=27583eea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27583eea"]])

export default __exports__